// localStorage key + URL query param that gate experimental beta features in
// the submit settings popover (e.g. the shorts curation prompt field). Captured
// in `app/_providers/app-providers.tsx` (and marketing providers) whenever a
// `?experimental=true` query param is detected.
export const EXPERIMENTAL_KEY = "experimental";
export const EXPERIMENTAL_QUERY_PARAM = "experimental";

// Whether experimental features should be available to the user. Reads the
// persisted localStorage flag set when the `?experimental=true` param was
// seen. Returns false during SSR (no `window`).
export const isExperimentalEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(EXPERIMENTAL_KEY) === "true";
  } catch {
    return false;
  }
};
